'use client'

import Bugsnag from '@bugsnag/js'
import { useEffect } from 'react'

import { ErrorView } from '@/app/[locale]/_components/ErrorView'
import useNotFoundData from '@/hooks/useNotFoundData'
import type { AppLocale } from '@/types/general'

interface Props {
	readonly error: Error
	readonly locale: AppLocale
}

export default function Err({ error, locale }: Props) {
	useEffect(() => {
		Bugsnag.notify(error)
	}, [error])

	const { data } = useNotFoundData({ locale })

	return <ErrorView data={data?.data} />
}
